import cx from 'classnames'

import Icon from '@components/icon'

interface ModalGalleryCloseButtonProps {
  onClose: () => void
  className?: string
}

const ModalGalleryCloseButton = ({
  onClose,
  className,
}: ModalGalleryCloseButtonProps) => {
  return (
    <div
      onClick={onClose}
      className={cx(
        'absolute top-0 right-0 p-6 cursor-pointer z-20',
        className,
      )}
    >
      <Icon id="modal-image-close" name="Cross" />
    </div>
  )
}

export default ModalGalleryCloseButton
